import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'employmentType', pure: false })
export class EmploymentTypePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: any, ...args: any[]): any {
    if (!value || typeof value !== 'string' || value.trim() === '') {
      return null;
    }

    const lowerValue = value.toLowerCase();

    if (lowerValue.includes('full')) {
      return this.translate.instant('Vacancies.EmploymentFullTime');
    }

    if (lowerValue.includes('part')) {
      return this.translate.instant('Vacancies.EmploymentPartTime');
    }

    if (lowerValue.includes('contract')) {
      return this.translate.instant('Vacancies.EmploymentContract');
    }

    if (lowerValue.includes('internship') || lowerValue.includes('intern')) {
      return this.translate.instant('Vacancies.EmploymentInternship');
    }

    if (lowerValue.includes('freelance')) {
      return this.translate.instant('Vacancies.EmploymentFreelance');
    }

    if (lowerValue.includes('temp')) {
      return this.translate.instant('Vacancies.EmploymentTemporary');
    }

    if (lowerValue.includes('volunteer')) {
      return this.translate.instant('Vacancies.EmploymentVolunteer');
    }

    return this.translate.instant('Vacancies.NotSelected');
  }

}
